// --- 缴费管理 --- //

export default [
  {
    name: 'paymentMonth',
    path: '/supplySystem/:supplyId/paymentManagement/paymentMonth/list',
    meta: { title: '缴费月份列表' },
    component: require('business/supplySystem/paymentManagement/paymentMonth/list.vue').default
  },
  {
    name: 'paymentMonthDetail',
    path: '/supplySystem/:supplyId/paymentManagement/paymentMonth/detail',
    meta: { title: '缴费月份详情' },
    component: require('business/supplySystem/paymentManagement/paymentMonth/detail.vue').default
  },
  {
    name: 'paymentMember',
    path: '/supplySystem/:supplyId/paymentManagement/paymentMember/list',
    meta: { title: '缴费人员列表' },
    component: require('business/supplySystem/paymentManagement/paymentMember/list.vue').default
  },
  {
    name: 'paymentSetting',
    path: '/supplySystem/:supplyId/paymentManagement/paymentSetting',
    meta: { title: '缴费设置' },
    component: require('business/supplySystem/paymentManagement/paymentSetting/list.vue').default
  }
]
